module.exports = __webpack_public_path__ + "static/search_graphic-5a133ea1aaadfeeb03d80933ddfc5fd4.jpg";